import React, { Component, createRef } from 'react';
import { Button, Checkbox, Col, Form, Input, message, Modal, Row } from 'antd';
import { object, array } from 'prop-types';
import API from '../../../api';
import { refreshAll } from '../../common/promise-loader';
import editIcon from '../../../assets/images/edit-icon.svg';

const { TextArea } = Input;

class EditCommentButton extends Component {
  static propTypes = {
    comment: object,
    stages: array
  };

  formRef = createRef();

  constructor (props) {
    super(props);
    const { comment: { sellerVisible, buyerVisible } } = this.props;
    this.state = {
      visible: false,
      sellerVisible: sellerVisible,
      buyerVisible: buyerVisible
    };
  }

  showModal = () => {
    this.setState({ visible: true });
  };

  closeModal = () => {
    this.setState({ visible: false });
  };

  handleOk = () => {
    this.formRef.submit();
  };

  handleCancel = () => {
    this.closeModal();
  };

  handleSubmit = ({ content }) => {
    const { comment: { id } } = this.props;
    const { sellerVisible, buyerVisible } = this.state;

    API.staff.updateComment(id, {
      content,
      sellerVisible,
      buyerVisible
    }).then(() => {
      this.setState({ visible: false });
      refreshAll();
      message.success('Comentario editado');
    });
  };

  getInitialValues = () => {
    const { comment } = this.props;
    const { stageId, content } = comment;
    return {
      stageId,
      content
    };
  };

  render () {
    const { sellerVisible, buyerVisible } = this.state;
    return (
      <>
        <Button type="link" onClick={this.showModal}>
          <img src={editIcon} alt="edit icon"/>
        </Button>
        <Modal
          title="Editar comentario"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={920}
        >
          <Form onFinish={this.handleSubmit} initialValues={this.getInitialValues()} ref={(ref) => { this.formRef = ref; }} autocomplete="off">
            <Row gutter={16}>
              <Col span={14}>
                <Form.Item label="Comentario" name="content">
                  <TextArea/>
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="Visible vendedor">
                  <Checkbox checked={sellerVisible} onChange={({ target: { checked: visible } }) => this.setState({ sellerVisible: visible })}/>
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="Visible comprador">
                  <Checkbox checked={buyerVisible} onChange={({ target: { checked: visible } }) => this.setState({ buyerVisible: visible })}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    );
  }
}

export default EditCommentButton;
